import { render, staticRenderFns } from "./QuestionCard.vue?vue&type=template&id=462be7ba&scoped=true"
import script from "./QuestionCard.vue?vue&type=script&lang=js"
export * from "./QuestionCard.vue?vue&type=script&lang=js"
import style0 from "./QuestionCard.vue?vue&type=style&index=0&id=462be7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462be7ba",
  null
  
)

export default component.exports